import create from 'zustand';
import { CreatePaymentMethodSteps } from '../components/shared/modals/CreateAdyenPaymentMethod/CreateAdyenPaymentMethodConstants';
import { BankAccountType } from '../components/shared/modals/CreateAdyenPaymentMethod/CreateBankAccount/CreateBankAccountConstants';

export type CreatePaymentMethodStoreState = {
    isCreatePaymentMethodModalOpen: boolean,
    currentStep: CreatePaymentMethodSteps,
    paymentMethodType: BankAccountType | null,
    mandateId: string | null,
};

type CreatePaymentMethodStoreActions = {
    setCreatePaymentMethodModalOpen: (isOpen: boolean) => void,
    setCurrentStep: (step: CreatePaymentMethodSteps) => void,
    setPaymentMethodType: (type: BankAccountType | null) => void,
    resetPaymentMethodState: () => void,
    setMandateId: (mandateId: string | null) => void,
    openAcceptMandateModal: (mandateId: string) => void,
};

export type CreatePaymentMethodStore = CreatePaymentMethodStoreState & CreatePaymentMethodStoreActions;

const CREATE_PAYMENT_METHOD_STORE_INITIAL_STATE: CreatePaymentMethodStoreState = {
    isCreatePaymentMethodModalOpen: false,
    currentStep: CreatePaymentMethodSteps.SELECT_PAYMENT_METHOD,
    paymentMethodType: null,
    mandateId: null,
};

export const createPaymentMethodStoreDefinition = (set): CreatePaymentMethodStore => ({
    ...CREATE_PAYMENT_METHOD_STORE_INITIAL_STATE,
    setCreatePaymentMethodModalOpen: (isOpen: boolean) => set({ isCreatePaymentMethodModalOpen: isOpen }),
    setCurrentStep: (step: CreatePaymentMethodSteps) => set({ currentStep: step }),
    setPaymentMethodType: (type: BankAccountType | null) => set({ paymentMethodType: type }),
    resetPaymentMethodState: () => set(CREATE_PAYMENT_METHOD_STORE_INITIAL_STATE),
    setMandateId: (mandateId: string | null) => set({ mandateId }),
    openAcceptMandateModal: (mandateId: string) => set({
        isCreatePaymentMethodModalOpen: true,
        currentStep: CreatePaymentMethodSteps.BANK_ACCOUNT_ACCEPT_MANDATE,
        mandateId,
    }),
});

export const useCreatePaymentMethodStore = create<CreatePaymentMethodStore>(createPaymentMethodStoreDefinition);
